module.exports = __webpack_public_path__ + "a05a81455cca24b30679e6026926b410.png";